import { Flex, Center, Button, Heading, Text, VStack } from '@chakra-ui/react';
import { useMemo, useState } from 'react';
import toast from 'react-hot-toast';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { thumbsUpIcon } from '../../pages/dashboard/components/Icons';
import { place_order } from '../../redux/actions/productActions';
import OrderCompleteModal from './OrderCompleteModal';
import { useScreenWidth } from 'hooks/useScreenWidth';

const DeliveryModal = ({ isModalOpen, closeModal, id }) => {
    const productReducer = useSelector((state) => state.productReducer);
    const { quoteId } = productReducer;
    const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
    const closeOrderModal = () => setIsOrderModalOpen(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const screen = useScreenWidth();

    const openOrderModal = () => {
        setIsOrderModalOpen(true);
    };

    let orderObject = useMemo(() => {
        return {
            quoteId,
            data: {
                paymentMethod: {
                    method: 'cashondelivery',
                },
            },
        };
    }, [quoteId]);

    const placeOrder = () => {
        toast.promise(
            dispatch(place_order(orderObject)),
            {
                loading: 'Placing...',
                success: <b> Order Placed</b>,
                error: <b>Could not place order.</b>,
            },
            { position: 'top-right' },
        );
    };

    return (
        <Modal
            isOpen={isModalOpen}
            onRequestClose={() => closeModal()}
            className="Modal"
            overlayClassName="Overlay">
            <Container>
                <Heading as="h4" textAlign="center" fontSize="24px" mt="20px">
                    Order Complete
                </Heading>
                <Text fontSize="16px" textAlign="center" mt="15px">
                    You have successfully Created your first Order{' '}
                </Text>
                <Flex
                    borderRadius="10px"
                    w="220px"
                    h="190px"
                    bg="#1b3b5f"
                    mt="30px"
                    mx="auto"
                    justify="center"
                    align="center">
                    <Center>{thumbsUpIcon}</Center>
                </Flex>
                <VStack mt="20px">
                    <Button
                        w="100%"
                        color="#F5F5F5"
                        bg="#1b3b5f"
                        mt="15px"
                        fontWeight="400"
                        borderRadius="48px"
                        h="48px"
                        outline="none"
                        onClick={() => {
                            closeModal();
                            // navigate(`/`, { replace: true });
                            navigate(
                                screen > 500 ? `/dashboard/invoices/${id}` : `/invoices/${id}`,
                                {
                                    replace: true,
                                },
                            );
                        }}>
                        Preview Invoice
                    </Button>
                    <Button
                        w="100%"
                        color="#202325"
                        bg="white"
                        mt="15px"
                        fontWeight="400"
                        borderRadius="48px"
                        outline="none"
                        onClick={async () => {
                            openOrderModal();
                            await placeOrder();
                            await navigate(`/dashboard`, { replace: true });
                        }}>
                        Place Order
                    </Button>
                </VStack>
                <OrderCompleteModal
                    isOrderModalOpen={isOrderModalOpen}
                    closeOrderModal={closeOrderModal}
                    closeModal={closeModal}
                    id={quoteId}
                />
            </Container>
        </Modal>
    );
};

export default DeliveryModal;

const Container = styled.div`
    width: 380px;
    max-height: 100%;
    background: #ffffff;
    border-radius: 16px 16px 16px 16px;
    padding: 24px 24px;
    padding-bottom: 50px;

    @media screen and (max-width: 500px) {
        padding: 18px 18px;
        width: 100vw;
        max-height: 100%;
        background: #ffffff;
        border-radius: 16px 16px 0px 0px;
    }
    a {
        width: 95%;
        border-radius: 5px;
        padding: 4px;
        height: 44px;
        font-size: 20px;
    }
    .active-link {
        background: rgba(33, 33, 241, 0.1);
        color: #1b3b5f;
        font-weight: 700;
        svg {
            path {
                stroke: #1b3b5f;
            }
        }
    }
`;
